import { z } from "zod";
import { LookupListPage } from "./LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { mapId: number; description: string; macFileSystemPrefix: string | null; windowsFileSystemPrefix: string | null; saveWithPrefix: string | null; deleted: boolean; }
const schema = z.object({
  description: z.string().min(1).max(200),
  macFileSystemPrefix: z.string().max(400).nullable().optional(),
  windowsFileSystemPrefix: z.string().max(400).nullable().optional(),
  saveWithPrefix: z.string().max(20).nullable().optional(),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function FileMappingsPage() {
  return <LookupListPage<Row, Form>
    title="File mappings"
    apiPath="/api/lookups/file-mappings"
    schema={schema}
    rowKey={(r) => r.mapId}
    columns={[
      { id: "desc",  header: "Description", accessor: (r) => r.description },
      { id: "mac",   header: "Mac prefix", accessor: (r) => r.macFileSystemPrefix ?? "—" },
      { id: "win",   header: "Windows prefix", accessor: (r) => r.windowsFileSystemPrefix ?? "—" },
      { id: "save",  header: "Save-with", accessor: (r) => r.saveWithPrefix ?? "—" },
    ]}
    toFormValues={(r) => ({ description: r.description, macFileSystemPrefix: r.macFileSystemPrefix ?? "", windowsFileSystemPrefix: r.windowsFileSystemPrefix ?? "", saveWithPrefix: r.saveWithPrefix ?? "", deleted: r.deleted })}
    toApiBody={(f) => f}
    blankFormValues={{ description: "", macFileSystemPrefix: "", windowsFileSystemPrefix: "", saveWithPrefix: "", deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="d">Description</Label><Input id="d" {...f.register("description")} /></div>
        <div><Label htmlFor="m">Mac prefix</Label><Input id="m" {...f.register("macFileSystemPrefix")} /></div>
        <div><Label htmlFor="w">Windows prefix</Label><Input id="w" {...f.register("windowsFileSystemPrefix")} /></div>
        <div><Label htmlFor="s">Save-with prefix</Label><Input id="s" {...f.register("saveWithPrefix")} /></div>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
